export default function Hero(){
  return (
    <section className="relative overflow-hidden bg-[#080B14] pt-12 pb-20">
      <div className="absolute inset-0 bg-[radial-gradient(600px_at_20%_10%,rgba(16,185,129,0.12),transparent),radial-gradient(800px_at_80%_40%,rgba(56,189,248,0.08),transparent)]" />

      <div className="relative max-w-7xl mx-auto px-6 grid lg:grid-cols-[1.1fr_0.9fr] gap-10 items-center">
        <div>
          <div className="flex flex-wrap gap-2 mb-6">
            <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-purple-500/10 border border-purple-500/20 text- text-purple-300">✦ meUusSoulAI · Guided Reflection Pilot</span>
            <span className="inline-flex px-3 py-1 rounded-full bg-slate-800 border border-slate-700 text- text-slate-400">Sixty Dome Heritage Sanctuary, Bagerhat</span>
          </div>

          <h1 className="font-serif text-5xl md:text- leading-[0.95] tracking-tight text-white">
            Understand Yourself Deeply.<br/>
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-emerald-300 to-cyan-300 underline decoration-emerald-500/50 underline-offset-8">Act with Sincerity & Courage.</span>
          </h1>

          <p className="mt-6 text- leading-relaxed text-slate-300 max-w-xl">
            A quiet, private, ethical pause in a chaotic world. Ask real questions about identity, stress, family harmony, or career crossroads and receive structured compassionate clarity.
          </p>

          <div className="mt-6 p-4 rounded-2xl bg-slate-900/60 border border-slate-800 text-sm text-slate-300 italic">
            “Before anything else, let me ask you one honest question: How are you — really?”
          </div>

          <div className="mt-8 flex flex-wrap gap-3">
            <a href="#start" className="px-6 py-3 bg-emerald-500 hover:bg-emerald-400 text-slate-950 rounded-full font-bold text-sm">BEGIN SOUL REFLECTION →</a>
            <a href="#workspace" className="px-6 py-3 bg-slate-900 border border-slate-700 text-white rounded-full text-sm">▶ Open Workspace & Tasks</a>
          </div>

          <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-3">
            {[
              {k:'meuus.org',d:'Understand · 9 Pillars'},
              {k:'meuussoul.com',d:'Learn · Quran & Seerah'},
              {k:'meuus.app',d:'Reflect & Act · OS'},
              {k:'rujbel.org',d:'Archive · Living Narrative'},
            ].map(c=>(
              <div key={c.k} className="p-3 rounded-2xl bg-slate-900/50 border border-slate-800">
                <div className="text-xs font-bold text-white">{c.k}</div>
                <div className="text- text-slate-400">{c.d}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="relative">
          <div className="rounded- bg-slate-900 border border-slate-800 p-3 shadow-2xl">
            <div className="flex items-center justify-between mb-3 px-2">
              <div className="flex items-center gap-3">
                <img src="/founder-a01.jpeg" alt="Founder" className="w-10 h-10 rounded-full object-cover border border-emerald-500/30" onError={(e)=>(e.currentTarget.src='/preserved/journey/founder_whatsapp_20260712.jpeg')} />
                <div>
                  <div className="text-sm font-bold text-white">meUus Flagship</div>
                  <div className="text- text-emerald-400">me → U → us</div>
                </div>
              </div>
              <div className="flex gap-1 text-">
                <span className="px-2 py-1 rounded-full bg-emerald-500 text-slate-950 font-bold">3D Orbit</span>
                <span className="px-2 py-1 rounded-full bg-slate-800 text-slate-400">Telemetry</span>
              </div>
            </div>

            <div className="relative rounded- overflow-hidden bg-[#0B0F1A] aspect-[4/3] border border-slate-800">
              <img src="/preserved/desktop-home.jpg" alt="Desktop Preservation" className="absolute inset-0 w-full h-full object-cover opacity-60" />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-transparent to-transparent" />
              <div className="absolute bottom-3 left-3 right-3 flex justify-between text- text-slate-400">
                <span>Individual</span><span>U (Intelligence)</span><span>us (Civilization)</span>
              </div>
            </div>

            <div className="mt-3 grid grid-cols-3 gap-2 text-">
              <div className="p-2 rounded-xl bg-slate-800/50 text-slate-300">R60A Kernel · Live</div>
              <div className="p-2 rounded-xl bg-slate-800/50 text-slate-300">53 SVG Preserved</div>
              <div className="p-2 rounded-xl bg-emerald-500/10 border border-emerald-500/20 text-emerald-300">Claim ≤ Evidence</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
